import { getLatestConversationId } from 'actions/conversation/lib/conversation_helpers';

export default class TopicSuggestionsFetcher {
  constructor(context) {
    this.context = context;
  }

  fetch({ force } = { force: false }) {
    // If it ain't enabled, don't bother
    if (!this.context.stores.agentAssistanceConfig.get().isEnabled('topicSuggestions')) {
      return;
    }

    // If we're not on a customer page, it's fine
    const customerId = this.context.stores.currentLocation.get().customerId;
    if (!customerId) {
      return;
    }

    // If we're still waiting for conversations to load, wait
    const customerStores = this.context.stores.customers.storesFor(customerId);
    if (customerStores.conversations.isLoading()) {
      return;
    }

    const lastConversationId = getLatestConversationId(customerStores.conversations);
    const topicSuggestions = this.context.stores.topicSuggestions.findBy({
      customerId,
      conversationId: lastConversationId,
    });
    // If we've already received the topic suggestions for this customer / conversation, whatever,
    // unless we want to force the request.
    if (!force && topicSuggestions) {
      return;
    }

    this.context.gateways.topicSuggestions.request(customerId, lastConversationId);
    this.context.stores.topicSuggestions.setLoading();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/lib/topic_suggestions_fetcher.js